import React, { useContext, useEffect } from "react";
import { Button, Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { AccessGateContext } from "../../../context/accessGateContext";
import { historyVendorMock } from "../../../mocks/historyVendorMock";
import { vendorMainColumnMaxWidthSx } from "../../../config/vendorContentMaxWidth";

const HistoryVendor = () => {
    const { canAccessVendorArea } = useContext(AccessGateContext);
    const navigate = useNavigate();
  
    useEffect(() => {
      if (!canAccessVendorArea) {
        navigate("/");
      }
    }, [canAccessVendorArea, navigate]);

  return (
    <Box display="flex" flexDirection="column" sx={{ width: "100%", ...vendorMainColumnMaxWidthSx }}>
        <Box display="flex" alignItems="center" mb={2} onClick={() => navigate("/monitoraggio")} sx={{cursor: "pointer"}}>
          <Typography variant="body1" sx={{fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87", cursor: "pointer", ml: 1 }} >⬅ Monitoraggio</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}>Storico Esecuzioni</Typography>
        </Box>
        <Box sx={{ display: "flex", mt: 3 }}>
          <Box sx={{ display: "flex", alignItems: "start", mt: 1, gap: 2 }}>
            <Typography sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}>FILTRA PER</Typography>
            <Button variant="contained" endIcon={<KeyboardArrowDown />} sx={{ fontFamily: "Rubik", backgroundColor: "#0b3d87", color: "white", borderRadius: "7px", fontWeight: "bold", textTransform: "none" }}>Ultimi 7 giorni</Button>
            <Button variant="contained" endIcon={<KeyboardArrowDown />} sx={{ fontFamily: "Rubik", backgroundColor: "#0b3d87", color: "white", borderRadius: "7px", fontWeight: "bold", textTransform: "none" }}>Calendar</Button>
          </Box>
          <Box sx={{ display: "flex", ml: 3, gap: 3 }}>
            <Box>
              <Typography sx={{ fontFamily: "Rubik", fontSize: 20, fontWeight: "bold", color: "#0b3d87" }}>Totali Record Importati</Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "10px", border: "1px solid rgb(200, 200, 200)" }}>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 14, fontWeight: "normal", color: "#0b3d87" }}>Numero minimo</Typography>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 20, fontWeight: "bold", color: "#0b3d87" }}>--</Typography>
                </Box>
                <Box sx={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "10px", border: "1px solid rgb(200, 200, 200)" }}>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 14, fontWeight: "normal", color: "#0b3d87" }}>Numero massimo</Typography>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 20, fontWeight: "bold", color: "#0b3d87" }}>--</Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Typography sx={{ fontFamily: "Rubik", fontSize: 20, fontWeight: "bold", color: "#0b3d87" }}>Totali Record In Errore</Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "10px", border: "1px solid rgb(200, 200, 200)" }}>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 14, fontWeight: "normal", color: "#0b3d87" }}>Numero minimo</Typography>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 20, fontWeight: "bold", color: "#0b3d87" }}>--</Typography>
                </Box>
                <Box sx={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "10px", border: "1px solid rgb(200, 200, 200)" }}>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 14, fontWeight: "normal", color: "#0b3d87" }}>Numero massimo</Typography>
                  <Typography sx={{ fontFamily: "Rubik", fontSize: 20, fontWeight: "bold", color: "#0b3d87" }}>--</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 3, overflow: "hidden", boxShadow: 2, mt: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#003366" }}>
              <TableRow>
                {["DATA E ORA IMPORT", "TOT. RECORD FILE", "TOT. RECORD IMPORTATI", "TOT. RECORD IN ERRORE", "E-COMMERCE"].map((header, index) => (
                  <TableCell key={index} sx={{ fontFamily: "Rubik", color: "white", fontWeight: "bold" }}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {historyVendorMock.map((row, index) => (
                <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#f0f5ff" : "white" }}>
                  <TableCell sx={{ fontFamily: "Rubik" }}>{row.date}</TableCell>
                  <TableCell sx={{ fontFamily: "Rubik" }}>{row.fileRecords}</TableCell>
                  <TableCell sx={{ fontFamily: "Rubik" }}>{row.importedRecords}</TableCell>
                  <TableCell sx={{ fontFamily: "Rubik" }}>{row.errorRecords}</TableCell>
                  <TableCell sx={{ fontFamily: "Rubik" }}>{row.ecommerce}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
    </Box>
  );
};

export default HistoryVendor;

